import axios from "../axios";

const payment = {
  paymentStripe(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("stripe/processed_payment", data)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  walletRecharge(data) {
    return new Promise((resolve, reject) => {
      
      axios
        .post("/add-money-to-wallet", data)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  // Retour de Stripe : l'API vérifie la session avant de confirmer l'achat
  confirmCheckout(sessionId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`payments/confirm?session_id=${encodeURIComponent(sessionId)}`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  // Retour « annuler » de Stripe : annule la demande et rend la part du portefeuille
  cancelCheckout(transactionId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`payments/${encodeURIComponent(transactionId)}/cancel`)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};

export default payment;
